import { CdkMenu, CdkMenuItem } from '@angular/cdk/menu';
import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { MunicipalityWithOutage } from '../../../../models/power-outage.model';
import { AffectedCountPipe } from '../../../../pipes/affected-count.pipe';
import { OutageTypePipe } from '../../../../pipes/outage-type.pipe';
import { DotComponent } from '../../../dot/dot.component';
import { InfoContainerStore } from '../../info-container.store';

@Component({
  selector: 'app-municipality-list',
  imports: [CdkMenu, CdkMenuItem, AffectedCountPipe, DotComponent, OutageTypePipe],
  templateUrl: './municipality-list.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MunicipalityListComponent {
  private readonly infoContainerStore = inject(InfoContainerStore);

  protected readonly municipalities = this.infoContainerStore.municipalitiesWithOutages;

  protected setSelectedMunicipality(municipalityWithOutage: MunicipalityWithOutage | undefined) {
    this.infoContainerStore.setSelectedMunicipality(municipalityWithOutage);
    this.infoContainerStore.setView('municipality');
  }
}
